import {
  Button,
  Tile,
  RowWrapper,
  ContainerTile,
  Wrapper,
  H1,
} from "components/styled-components/generic";
import { drivingStylesOpts } from "constants/driving-styles";
import { FC } from "react";
import { DrivingStyles, DrivingFactor } from "shared-types";

interface DrivingStyleProps {
  setDrivingStyle: (p: DrivingStyles) => void;
  drivingStyle: DrivingStyles;
  setDrivingFactor: (p: DrivingFactor) => void;
  drivingFactor: DrivingFactor;
}

const DrivingStyle: FC<DrivingStyleProps> = ({
  setDrivingStyle,
  drivingStyle,
  setDrivingFactor,
}) => {
  return (
    <ContainerTile>
      <Wrapper>
        <H1>Fahrstil</H1>
      </Wrapper>
      <RowWrapper>
        {drivingStylesOpts.map((styleOpt) => {
          return (
            <Tile key={styleOpt.id}>
              <Button
                width="160px"
                onClick={() => {
                  setDrivingStyle(styleOpt.id);
                  setDrivingFactor(styleOpt.factor);
                }}
                active={styleOpt.id === drivingStyle}
              >
                {styleOpt.name}
              </Button>
            </Tile>
          );
        })}
      </RowWrapper>
    </ContainerTile>
  );
};

export default DrivingStyle;
